import React, { useState, useEffect, useRef } from 'react';
import '../styles/modal.css';

const TailorModal = ({ isOpen, onClose, onSubmit, setFile, file, betaTesting, setBetaInfo, betaInfo }) => {
  const [jobDescription, setJobDescription] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const suggestionsRef = useRef(null);
  const MAX_FILE_SIZE = 2.5 * 1024 * 1024; // 2.5 MB
  // Close suggestions when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (suggestionsRef.current && !suggestionsRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (!isOpen) return null;


  const handleBetaInfoChange = (e) => {
    const { name, value } = e.target;
    setBetaInfo(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate inputs
    if (!file) {
      alert("Please upload a resume file");
      return;
    }


    if (!jobDescription) {
      alert("Please enter a job description");
      return;
    }

    // Create the form data
    const formData = new FormData();
    formData.append('resume', file);
    formData.append('jobDescription', jobDescription);
    formData.append('jobTitle', jobTitle);

    // Add beta info directly to the FormData
    if (betaTesting) {
      formData.append('promoCode', betaInfo.promoCode);
      formData.append('email', betaInfo.email);
    }

    // Debug output
    console.log("Tailor form data being sent:", {
      hasFile: !!file,
      jobTitle,
      jobDescriptionLength: jobDescription.length,
      betaTesting,
      betaInfo
    });

    // Call onSubmit directly with the form data
    onSubmit(formData);
  };

  return (
    <div className="modal-container">
      <div className="modal-card">
        <h2>Tailor Resume</h2>
        <p className="modal-subtitle">Provide your resume and target job details</p>

        <form onSubmit={handleSubmit}>
          <div className="modal-form-section">
            <label>Upload Resume</label>
            <div className="file-upload-container">
              <button
                type="button"
                className="file-upload-button"
                onClick={() => document.getElementById('tailor-file-input').click()}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="17 8 12 3 7 8"></polyline>
                  <line x1="12" y1="3" x2="12" y2="15"></line>
                </svg>
                Choose File
              </button>
              <span className="file-name">{file ? file.name : "No File Chosen"}</span>
              <input
                type="file"
                id="tailor-file-input"
                accept=".pdf,.doc,.docx"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (!file) return;

                  if (file.size > MAX_FILE_SIZE) {
                    alert(`File is too large. Max allowed size is ${MAX_FILE_SIZE / (1024 * 1024)} MB.`);
                    e.target.value = ""; // clears the file input
                    return;
                  }

                  setFile(file); // safe to keep
                }}
                required={!file}
                style={{ display: 'none' }}
              />
            </div>
          </div>

          <div className="modal-form-section">
            <label>Job Description</label>
            <textarea
              placeholder="Paste the job description here"
              value={jobDescription}
              onChange={(e) => setJobDescription(e.target.value)}
              required
            />
          </div>

          {betaTesting && (
            <div className="beta-testing-section">
              <h3>Beta Testing Access</h3>
              <div className="beta-fields-container">
                <div className="modal-form-section">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={betaInfo.email}
                    onChange={handleBetaInfoChange}
                    required
                  />
                </div>
                <div className="modal-form-section">
                  <label>Promo Code</label>
                  <input
                    type="text"
                    name="promoCode"
                    placeholder="Enter your promo code"
                    value={betaInfo.promoCode}
                    onChange={handleBetaInfoChange}
                    required
                  />
                </div>
              </div>
            </div>
          )}

          <div className="modal-actions">
            <button type="button" className="modal-btn-secondary" onClick={() => {
              setFile(null);
              setJobTitle('');
              setJobDescription('');
              // Reset file input by accessing the DOM element
              const fileInput = document.getElementById('tailor-file-input');
              if (fileInput) fileInput.value = '';
            }}>
              Clear
            </button>
            <button type="submit" className="modal-btn-primary">
              Continue
              <svg xmlns="http://www.w3.org/2000/svg" className="file-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TailorModal; 